module.exports = __webpack_public_path__ + "img/SketchPngb6c95d52234bc0dcf9d3d06623cc8eb6d237a8c451b75e0ce634f53f51bd978e.b870751e.png";